const Logo = () => (
  <img
    className="mx-auto mb-xl mt-xs w-[220px]"
    src="/images/freddie-logo-green.svg"
    alt="Freddie"
  />
);

export default Logo;
